export const config = {
    appname: 'thailife',
    prefix: 'THL',
    app_id: '1737548692935071',
    facebook_app_id: '1737548692935071',
    debug: false,

    // ------------- Production Settings ----------------
    api: 'apithl2',
    agency_id: '',
    bzbs_url: 'https://apithl2.buzzebees.com',
    bzbs_module_url: 'https://thailifemodule.buzzebees.com',
    bzbs_add_item_from_list: 'https://apithl.buzzebees.com/api/cart/',
    bzbs_blob_url: 'https://buzzebees.blob.core.windows.net',
    bzbs_shopping_cart_url: 'https://cartthl.buzzebees.com',
    bzbs_add_item: 'https://cartthl.buzzebees.com/payment/AddItem.aspx?id=',
    bzbs_shopping_basket: 'https://cartthl.buzzebees.com/paymentV2/cart.aspx',
    bzbs_web_url: 'https://www.buzzebees.com',
    bzbs_point_expire: 'https://www.buzzebees.com/Views/Point/Expire.aspx?token=',
    api_shoppingcart_url: 'https://shoppingcartmodule34.buzzebees.com',
    web_shoppingcart_url: 'https://shoppingcartservice34.buzzebees.com',
    misc_url: 'https://misc.buzzebees.com',
    bzbs_ga_id: '',
    thailife_consent_url: 'https://superapp-api.thailife.com/buzzebees',
    // ------------------ End Settings ---------------------

    fb_log_on_url: 'https://www.facebook.com/dialog/oauth?',
    fb_permissions: [
        'email',
    ],
    mainConfig: {
        DashboardConfig: "dashboard_thailife",
        MenuConfig: "menu_thailife",
        CampaignListConfig: "campaign_thailife",
        CampaignHeaderConfig: "thailife",
        purchaseListConfig: "purchase"
    },
};
